import { IonContent } from "@ionic/react";
import React, { useEffect } from "react";
import { connect } from "react-redux";

import { AppHeader } from "../../components/Header/AppHeader";
import UsersModule from "../Users/components/UsersModule";
import UserDashboard from "../Users/User/components/UserDashboard";

export interface Props {
	user: any;
}

const Dashboard: React.FC<Props> = ({ user }) => {

	return (
		<>
			<AppHeader title="Dashboard" />
			<IonContent fullscreen className="ion-padding dashboard">
				<div className="container">
					{user.isAdmin && <UsersModule />}
					{!user.isAdmin && <UserDashboard user={user} />}
				</div>
			</IonContent>
		</>
	);
};

const mapStateToProps = (state: any) => ({
	user: state.user.userDetails,
	users: state.user.users,
});

export default connect(mapStateToProps, {})(Dashboard);
